export default "__VITE_ASSET__C4mY1jnq__"